import React, { useRef } from 'react';
import { NumericFormat as BaseNumericFormat } from 'react-number-format';

// Select on entry so typing replaces the amount; later clicks can edit a digit.
export const NumericFormat = ({ onFocus, onMouseDown, onMouseUp, ...props }) => {
  const selectOnMouseUp = useRef(false);

  const selectValue = (input) => {
    if (input && !input.disabled && !input.readOnly &&
        input.ownerDocument.activeElement === input) {
      input.select?.();
    }
  };

  return (
    <BaseNumericFormat
      {...props}
      onMouseDown={(event) => {
        selectOnMouseUp.current = event.target.ownerDocument.activeElement !== event.target;
        onMouseDown?.(event);
      }}
      onFocus={(event) => {
        onFocus?.(event);
        const input = event.target;
        // Run after the formatter has finished positioning its caret.
        setTimeout(() => selectValue(input), 0);
      }}
      onMouseUp={(event) => {
        if (selectOnMouseUp.current) {
          selectValue(event.target);
          selectOnMouseUp.current = false;
        }
        onMouseUp?.(event);
      }}
    />
  );
};
